import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdWoofzOffer270 } from './pages'

type TIdToPageMapWoofzOffer270 = Record<PageIdWoofzOffer270, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZ_OFFER2_70: TIdToPageMapWoofzOffer270 = {
  [PageIdWoofzOffer270.SUBSCRIPTIONS_OFFER2_70]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_offer/woofz_offer2_70/pages/subscriptions/SubscriptionsOffer270'
      ).then((m) => ({
        default: m.SubscriptionsOffer270,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_offer/woofz_offer2_70/pages/subscriptions/SubscriptionsOffer270'
      ),
  },
  [PageIdWoofzOffer270.CHAT_UPSELL_OFFER2_70]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_offer/woofz_offer2_70/pages/upsell/ChatUpsellNewFlow'
      ).then((m) => ({
        default: m.ChatUpsellNewFlow,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_offer/woofz_offer2_70/pages/upsell/ChatUpsellNewFlow'
      ),
  },
  [PageIdWoofzOffer270.UPSELL_OFFER2_70]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_offer/woofz_offer2_70/pages/upsell/Upsell'
      ).then((m) => ({
        default: m.Upsell,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_offer/woofz_offer2_70/pages/upsell/Upsell'),
  },
  [PageIdWoofzOffer270.DOWNLOAD_OFFER2_70]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_offer/woofz_offer2_70/pages/download-app/DownloadApp'
      ).then((m) => ({
        default: m.DownloadApp,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_offer/woofz_offer2_70/pages/download-app/DownloadApp'
      ),
  },
  [PageIdWoofzOffer270.ACCOUNT_NOVE8]: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
}
